import React from "react";
//UI
import {
  Checkbox,
  Input,
  Radio,
  SearchInput,
  Select,
  Textarea,
} from "../../../../ui/inputs/Input";
import { InfoButton } from "../../../../ui/buttons/Button";
export default function Usuarios() {
  return (
    <div className="col-8 m-0 p-2 border rounded">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="m-0 fw-bold">Usuarios</h3>
        <a type="button" className="fw-bold text-light fs-6">
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </header>
      <ul class="nav nav-tabs col-12 m-0 my-2 p-0" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="usuario-tab"
            data-bs-toggle="tab"
            data-bs-target="#usuario-tab-pane"
            type="button"
            role="tab"
            aria-controls="usuario-tab-pane"
            aria-selected="true"
          >
            Usuario
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="permisos-tab"
            data-bs-toggle="tab"
            data-bs-target="#permisos-tab-pane"
            type="button"
            role="tab"
            aria-controls="permisos-tab-pane"
            aria-selected="false"
          >
            Permisos Aplicación Bienes Nacionales
          </button>
        </li>
      </ul>
      <div
        class="tab-content"
        id="myTabContent"
        style={{ height: 400, overflow: "auto" }}
      >
        <div
          class="tab-pane fade show active"
          id="usuario-tab-pane"
          role="tabpanel"
          aria-labelledby="usuario-tab"
          tabindex="0"
        >
          <div className="col-12 m-0 p-0 d-flex flex-wrap">
            <div className="col-2 m-0 p-0">
              <Input label="Código:" />
            </div>
            <div className="col-3 m-0 p-0 pl-2">
              <Input label="Nombre de Usuario:" />
            </div>
            <div className="col-3 m-0 p-0 d-flex input-group-sm pl-2">
              <Input label="Contraseña:" />
              <InfoButton icon="fa-eye m-0" className="rounded-0" />
            </div>
            <div className="col-4 m-0 p-0 d-flex input-group-sm pl-2">
              <Input label="Confirmar Contraseña:" />
              <InfoButton icon="fa-eye m-0" className="rounded-0" />
            </div>
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none w-auto m-0">Organización</legend>
              <div className="col-3 m-0 p-0 pr-2">
                <SearchInput label="Código:" />
              </div>
              <Input />
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos Personales
              </legend>
              <div className="col-12 m-0 p-0">
                <div className="col-3 m-0 mb-2 p-0 pr-2">
                  <SearchInput label="Cedula:" />
                </div>
              </div>
              <div className="col-6 m-0 mb-2 p-0">
                <Input label="Nombres:" />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input label="Apellidos:" />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Textarea label="Dirección:" style={{ height: 70 }} />
              </div>
              <div className="col-3 m-0 mb-2 p-0">
                <Input label="Correo Electrónico:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Telefono:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Celular:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Fecha de Nacimiento:" type="date" />
              </div>
              <div className="col-3 m-0 mb-2 p-0">
                <Select label="Nacionalidad:"></Select>
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Select label="Sexo:"></Select>
              </div>
            </fieldset>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="permisos-tab-pane"
          role="tabpanel"
          aria-labelledby="permisos-tab"
          tabindex="0"
        >
          <ul
            class="nav nav-tabs col-12 m-0 my-2 p-0"
            id="myTab"
            role="tablist"
          >
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="bienesNacionales-tab"
                data-bs-toggle="tab"
                data-bs-target="#bienesNacionales-tab-pane"
                type="button"
                role="tab"
                aria-controls="bienesNacionales-tab-pane"
                aria-selected="true"
              >
                Bienes Nacionales
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="reportes-tab"
                data-bs-toggle="tab"
                data-bs-target="#reportes-tab-pane"
                type="button"
                role="tab"
                aria-controls="reportes-tab-pane"
                aria-selected="false"
              >
                Reportes
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="configuracion-tab"
                data-bs-toggle="tab"
                data-bs-target="#configuracion-tab-pane"
                type="button"
                role="tab"
                aria-controls="configuracion-tab-pane"
                aria-selected="false"
              >
                Configuración
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent2">
            <div
              class="tab-pane fade show active"
              id="bienesNacionales-tab-pane"
              role="tabpanel"
              aria-labelledby="bienesNacionales-tab"
              tabindex="0"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <fieldset className="col-6 m-0 mb-2 p-2 d-flex flex-wrap justify-content-between gap-2 border-azul rounded">
                  <legend className="float-none w-auto m-0">
                    Catalogo de Activos
                  </legend>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Consultar"
                      id="consultar_catalogoActivos"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Incluir" id="incluir_catalogoActivos" />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Editar" id="editar_catalogoActivos" />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Eliminar" id="eliminar_catalogoActivos" />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Todas" id="todas_catalogoActivos" />
                  </div>
                </fieldset>
                <div className="col-6 m-0 mb-2 p-0 pl-2">
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between gap-2 border-azul rounded">
                    <legend className="float-none w-auto m-0">
                      Registro de Ubicaciones de Bienes
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Consultar"
                        id="consultar_registroUbicacionesBienes"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Incluir"
                        id="incluir_registroUbicacionesBienes"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Editar"
                        id="editar_registroUbicacionesBienes"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Eliminar"
                        id="eliminar_registroUbicacionesBienes"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Todas"
                        id="todas_registroUbicacionesBiens"
                      />
                    </div>
                  </fieldset>
                </div>
                <fieldset className="col-6 m-0 mb-2 p-2 d-flex flex-wrap gap-2 justify-content-between border-azul rounded">
                  <legend className="float-none w-auto m-0">
                    Motivos de Incorporación
                  </legend>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Consultar"
                      id="consultar_motivosIncorporacion"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Incluir"
                      id="incluir_motivosIncorporacion"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Editar"
                      id="editar_motivosIncorporacion"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Eliminar"
                      id="eliminar_motivosIncorporacion"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Todas" id="todas_motivosIncorporacion" />
                  </div>
                </fieldset>
                <div className="col-6 m-0 mb-2 p-0 pl-2">
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap gap-2 justify-content-between border-azul rounded">
                    <legend className="float-none w-auto m-0">
                      Motivos de Desincorporación
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Consultar"
                        id="consultar_motivosDesincorporacion"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Incluir"
                        id="incluir_motivosDesincorporacion"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Editar"
                        id="editar_motivosDesincorporacion"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Eliminar"
                        id="eliminar_motivosDesincorporacion"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Todas"
                        id="todas_motivosDesincorporacion"
                      />
                    </div>
                  </fieldset>
                </div>
                <fieldset className="col-6 m-0 mb-2 p-2 d-flex flex-wrap gap-2 justify-content-between border-azul rounded">
                  <legend className="float-none w-auto m-0">
                    Incorporación de Bienes Muebles
                  </legend>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Consultar"
                      id="consultar_incorporacionBienesMuebles"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Incluir"
                      id="incluir_incorporacionBienesMuebles"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Editar"
                      id="editar_incorporacionBienesMuebles"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Eliminar"
                      id="eliminar_incorporacionBienesMuebles"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Todas"
                      id="todas_incorporacionBienesMueble"
                    />
                  </div>
                </fieldset>
                <div className="col-6 m-0 mb-2 p-0 pl-2">
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap gap-2 justify-content-between border-azul rounded">
                    <legend className="float-none w-auto m-0">
                      Incorporación de Bienes Inmuebles
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Consultar"
                        id="consultar_incorporacionBienesInmuebles"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Incluir"
                        id="incluir_incorporacionBienesInmuebles"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Editar"
                        id="editar_incorporacionBienesInmuebles"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Eliminar"
                        id="eliminar_incorporacionBienesInmuebles"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Todas"
                        id="todas_incorporacionBienesInmuebles"
                      />
                    </div>
                  </fieldset>
                </div>
                <fieldset className="col-6 m-0 mb-2 p-2 d-flex flex-wrap gap-2 justify-content-between border-azul rounded">
                  <legend className="float-none w-auto m-0">
                    Desincorporación de Bienes Muebles
                  </legend>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Consultar"
                      id="consultar_desincorporacionBienesMuebles"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Incluir"
                      id="incluir_desincorporacionBienesMuebles"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Editar"
                      id="editar_desincorporacionBienesMuebles"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Eliminar"
                      id="eliminar_desincorporacionBienesMuebles"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Todas"
                      id="todas_desincorporacionBienesMuebles"
                    />
                  </div>
                </fieldset>
                <div className="col-6 m-0 mb-2 p-0 pl-2">
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap gap-2 justify-content-between border-azul rounded">
                    <legend className="float-none w-auto m-0">
                      Desincorporación de Bienes Inmuebles
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Consultar"
                        id="consultar_desincorporacionBienesInmuebles"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Incluir"
                        id="incluir_desincorporacionBienesInmuebles"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="editar"
                        id="editar_desincorporacionBienesInmuebles"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Eliminar"
                        id="eliminar_desincorporacionBienesInmuebles"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Todas"
                        id="todas_desincorporacionBienesInmuebles"
                      />
                    </div>
                  </fieldset>
                </div>
                <fieldset className="col-6 m-0 p-2 d-flex flex-wrap gap-2 justify-content-between border-azul rounded">
                  <legend className="float-none w-auto m-0">
                    Traslado Interno de Bienes
                  </legend>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Consultar"
                      id="consultar_trasladoInternoBienes"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Incluir"
                      id="incluir_trasladoInternoBienes"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Editar"
                      id="editar_trasladoInternoBienes"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Eliminar"
                      id="eliminar_trasladoInternoBienes"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Todas"
                      id="todas_trasladosInternoBienes"
                    />
                  </div>
                </fieldset>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="reportes-tab-pane"
              role="tabpanel"
              aria-labelledby="reportes-tab"
              tabindex="0"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <fielset className="col-6 m-0 mb-2 p-2 d-flex flex-wrap gap-2 border-azul rounded">
                  <span className="col-6 m-0 p-0 fw-bold">
                    Tipos de Activos
                  </span>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label="Disponible"
                      name="tiposActivos"
                      id="tiposActivos1"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label="No Disponible"
                      name="tiposActivos"
                      id="tiposActivos2"
                    />
                  </div>
                </fielset>
                <div className="col-6 m-0 mb-2 p-0 pl-2">
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap gap-2 border-azul rounded">
                    <span className="col-6 m-0 p-0 fw-bold">Ubicaciones</span>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="ubicaciones"
                        id="ubicaciones1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="ubicaciones"
                        id="ubicaciones2"
                      />
                    </div>
                  </fieldset>
                </div>
                <fieldset className = 'col-6 m-0 mb-2 p-2 d-flex flex-wrap gap-2 border-azul rounded'>
                  <span className = 'col-6 m-0 p-0 fw-bold'>Disposiciones</span>
                  <div className = 'col-auto m-0 p-0'>
                    <Radio label = 'Disponible' name = 'disposiciones' id = 'disponibilidad1' />
                  </div>
                  <div className = 'col-auto m-0 p-0'>
                    <Radio label = 'No Disponible' name = 'disposiciones' id = 'disponibilidad2' />
                  </div>
                </fieldset>
                <div className = 'col-6 m-0 mb-2 p-0 pl-2'>
                  <fieldset className = 'col-12 m-0 p-2 d-flex flex-wrap gap-2 border-azul rounded'>
                    <span className = 'col-6 m-0 p-0 fw-bold'>Listado de Incorporación de Bienes</span>
                    <div className = 'col-auto m-0 p-0'>
                      <Radio label = 'Disponible' name = 'listadoIncorporacionBienes' id = 'listadoIncorporacionBienes1' />
                    </div>
                    <div className = 'col-auto m-0 p-0'>
                      <Radio label = 'No Disponible' name = 'listadoIncorporacionBienes' id = 'listadoIncorporacionBienes2' />
                    </div>
                  </fieldset>
                </div>
                <fieldset className = 'col-6 m-0 m mb-2 p-2 d-flex flex-wrap gap-2 border-azul rounded'>
                  <span className = 'col-6 m-0 p-0 fw-bold'>Listado de Desincorporición de Bienes</span>
                  <div className = 'col-auto m-0 p-0'>
                    <Radio label = 'Disponible' name = 'listadoDesincorporacionBienes' id = 'listadoDesincorporacionBienes1' />
                  </div>
                  <div className = 'col-auto m-0 p-0'>
                    <Radio label = 'No Disponible' name = 'listadoDesincorporacionBienes' id = 'listadoDesincorporacionBienes2' />
                  </div>
                </fieldset>
                <div className = 'col-6 m-0 mb-2 p-0 pl-2'>
                  <fieldset className = 'col-12 m-0 p-2 d-flex flex-wrap gap-2 border-azul rounded'>
                    <span className = 'col-6 m-0 p-0 fw-bold'>Listado de Traslados de Bienes</span>
                    <div className = 'col-auto m-0 p-0'>
                      <Radio label = 'Disponible' name = 'listadoTrasladosBienes' id = 'listadoTrasladosBienes1' />
                    </div>
                    <div className = 'col-auto m-0 p-0'>
                      <Radio label = 'No Disponible' name = 'listadoTrasladosBienes' id = 'listadoTrasladosBienes2' />
                    </div>
                  </fieldset>
                </div>
                <fieldset className = 'col-6 m-0 mb-2 p-2 d-flex flex-wrap gap-2 border-azul rounded'>
                  <span className = 'col-6 m-0 p-0 fw-bold'>Inventario de Bienes Muebles</span>
                  <div className = 'col-auto m-0 p-0'>
                    <Radio label = 'Disponible' name = 'inventarioBienesMuebles' id = 'inventarioBienesMuebles1' />
                  </div>
                  <div className = 'col-auto m-0 p-0'>
                    <Radio label = 'No Disponible' name = 'inventarioBienesMuebles' id = 'inventarioBienesMuebles2' />
                  </div>
                </fieldset>
                <div className = 'col-6 m-0 mb-2 p-0 pl-2'>
                  <fieldset className = 'col-12 m-0 p-2 d-flex flex-wrap gap-2 border-azul roundes'>
                    <span className = 'col-6 m-0 p-0 fw-bold'>Resumen de Inventario de Bienes Muebles</span>
                    <div className = 'col-auto m-0 p-0'>
                      <Radio label = 'Disponible' name = 'resumenInventarioBienesMuebles' id = 'resumenInventarioBienesMuebles1' />
                    </div>
                    <div className = 'col-auto m-0 p-0'>
                      <Radio label = 'No Disponible' name = 'resumenInventarioBienesMuebles' id = 'resumenInventarioBienesMuebles2' />
                    </div>
                  </fieldset>
                </div>
                <fieldset className = 'col-6 m-0 mb-2 p-2 d-flex flex-wrap gap-2 border-azul rounded'>
                  <span className = 'col-6 m-0 p-0 fw-bold'>Movimientos de Bienes Muebles</span>
                  <div className = 'col-auto m-0 p-0'>
                    <Radio label = 'Disponible' name = 'movimientosBienesMuebles' id = 'movimientosBienesMuebles1' />
                  </div>
                  <div className = 'col-auto m-0 p-0'>
                    <Radio label = 'No Disponible' name = 'movimientosBienesMuebles' id = 'movimientosBienesMuebles2' />
                  </div>
                </fieldset>
                <div className = 'col-6 m-0 mb-2 p-0 pl-2'>
                  <fieldset className = 'col-12 m-0 p-2 d-flex flex-wrap gap-2 border-azul rounded'>
                    <span className = 'col-6 m-0 p-0 fw-bold'>Resumen Cuentas Bienes Muebles</span>
                    <div className = 'col-auto m-0 p-0'>
                      <Radio label = 'Disponible' name = 'resumenCuentasBienesMuebles' id = 'resumenCuentasBienesMuebles1' />
                    </div>
                    <div className = 'col-auto m-0 p-0'>
                      <Radio label = 'No Disponible' name = 'resumenCuentasBienesMuebles' id = 'resumenCuentasBienesMuebles2' />
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="configuracion-tab-pane"
              role="tabpanel"
              aria-labelledby="configuracion-tab"
              tabindex="0"
            >
             <fieldset className = 'col-6 m-0 p-2 d-flex flex-wrap gap-2 justify-content-between border-azul rounded'>
              <legend className = 'float-none w-auto m-0'>Módulo de Usuarios</legend>
              <div className = 'col-auto m-0 p-0'>
                <Checkbox label = 'Consultar' id = 'consultar_moduloUsuarios' />
              </div>
              <div className = 'col-auto m-0 p-0'>
                <Checkbox label = 'Incluir' id = 'incluir_moduloUsuarios' />
              </div>
              <div className = 'col-auto m-0 p-0'>
                <Checkbox label = 'Editar' id = 'editar_moduloUsuarios' />
              </div>
              <div className = 'col-auto m-0 p-0'>
                <Checkbox label = 'Eliminar' id = 'eliminar_moduloUsuarios' />
              </div>
              <div className = 'col-auto m-0 p-0'>
                <Checkbox label = 'Todas' id = 'todas_modulosUsuarios' />
              </div>
             </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
